import React, { useState } from 'react';
import { connect } from 'react-redux';
import css from './style.scss';
import Image from 'components/base/Image';
import nophoto from '../../../components/base/Image/nophoto.png';
import Vector from '../../../assets/images/Vector.svg';
import WhiteClose from '../../../assets/images/WhiteClose.svg';
import ImageDefault from '../../../assets/images/Img.svg';
import ImageHover from '../../../assets/images/HoverImg.svg';
import { openGallery } from '../../Property/Gallery/GalleryPortalRenderer';
import RightNav from '../../../assets/images/right-nav.svg';
import LeftNav from '../../../assets/images/left-nav.svg';
import PropertyDetailPopup from '../../Property/Detail/Detail';

const Carousel = ({
  className,
  loading,
  propertyId,
  images,
  history,
  imageUrlString,
  alt,
  placeholder,
  onCloseClick,
  onNearbyClick,
  showLinear,
  setInputFlag,
  
  // NEW: Feature flags
  nearbySearchEnabled = true,
  photoGalleryEnabled = true,
  closeButtonEnabled = true,
  hoverEffectsEnabled = true,
  cardStyle = 'default', // 'default' or 'compact'
  
  // DEPRECATED: Keep for backward compatibility
  hideNearby = false,
  hidePhoto = false,
  hideClose = false,
  context = 'map',
  
  dispatch
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState('');
  const [isClicked, setIsClicked] = useState(false);
  const [isImageHovered, setIsImageHovered] = useState(false);

  // BACKWARD COMPATIBILITY: Map old props to new behavior
  const isCompactMode = context === 'campaign' || cardStyle === 'compact';
  const showNearbyButton = !hideNearby && nearbySearchEnabled && !isCompactMode;
  const showPhotoButton = !hidePhoto && photoGalleryEnabled && images && !isCompactMode;
  const showCloseButton = !hideClose && closeButtonEnabled && !isCompactMode;
  const enableHover = hoverEffectsEnabled && !isCompactMode;

  const cleanedUrl = typeof imageUrlString === 'string' ? imageUrlString.trim() : '';
  const isFallbackImage = !cleanedUrl || cleanedUrl.includes('coming_soon') || cleanedUrl.includes('placeholder');
  const imageUrls = isFallbackImage ? [nophoto] : cleanedUrl.split(',').map(url => url.trim()).filter(Boolean);

  const goPrev = (e) => {
    e.stopPropagation();
    if (currentIndex > 0) {
      setDirection('left');
      setCurrentIndex(currentIndex - 1);
    }
  };

  const goNext = (e) => {
    e.stopPropagation();
    if (currentIndex < imageUrls.length - 1) {
      setDirection('right');
      setCurrentIndex(currentIndex + 1);
    }
  };

  const selectIndex = (index) => {
    if (index !== currentIndex) {
      setDirection(index > currentIndex ? 'right' : 'left');
      setCurrentIndex(index);
    }
  };

  const handleDetailsClick = () => {
    if (isCompactMode) {
      const campaignId = history.location.pathname.match(/\/campaign\/(\d+)\/dialer/)?.[1];
      if (campaignId) {
        const action = PropertyDetailPopup.open({
          propertyId,
          preventRouting: true,
          match: { params: { id: propertyId } }
        });
        if (dispatch) {
          dispatch(action);
        } else {
          console.error('Dispatch is not available in Carousel');
        }
      } else {
        // Fallback if regex doesn't match
        history.push(`/campaign/${propertyId}`);
      }
    } else {
      history.push(`/search/${propertyId}`);
    }
  };

  const handleGalleryClick = () => {
    openGallery({ id: propertyId });
  };

  const handleMouseEnter = () => {
    if (enableHover) {
      setIsImageHovered(true);
      if (showLinear) {
        showLinear(true);
      }
    }
  };

  const handleMouseLeave = () => {
    if (enableHover) {
      setIsImageHovered(false);
      if (showLinear) {
        showLinear(false);
      }
    }
  };


  if (!imageUrls.length) return <p>No images to show</p>;

  return (
    <div className={`${css.carouselContainer} ${isCompactMode ? css.compactCarousel : ''} ${isImageHovered ? css.showHoverUI : ""}`}>
      <div className={`${css.carouselImageWrapper} ${isCompactMode ? css.compactWrapper : ''}`}>
        <div className={css.buttonContainer}>
          {loading != true &&
            <div className={css.details}>
              {showNearbyButton && (
                <button
                  type="button"
                  className={css.textButton}
                  onClick={() => {
                    onNearbyClick(propertyId);
                  }}
                >
                  Nearby
                </button>
              )}
              <button className={css.textButton} onClick={handleDetailsClick}>Details</button>
            </div>
          }
          {showPhotoButton && (
            <button
              className={`${css.imageIconButton} ${isClicked ? css.clicked : ''}`}
              onClick={handleGalleryClick}
              onMouseDown={() => setIsClicked(true)}
              onMouseUp={() => setIsClicked(false)}
              onMouseLeave={() => setIsClicked(false)}
            >
              <img src={ImageDefault} alt="Default" className={`${css.imageIcon} ${css.imgDefaultIcon}`} />
              <img src={ImageHover} alt="Hover" className={`${css.imageIcon} ${css.imgHoverIcon}`} />
            </button>
          )}
          {showCloseButton && (
            <button onClick={onCloseClick} className={css.closeIconButton}>
              <img src={Vector} alt="Close" className={`${css.closeIcon} ${css.defaultIcon}`} />
              <img src={WhiteClose} alt="Close Hover" className={`${css.closeIcon} ${css.hoverIcon}`} />
            </button>
          )}
        </div>

        {/* Hover Region with Arrows and Image */}
        <div
          className={`${css.hoverGroup} ${isImageHovered ? '' : css.noExpand}`}
        >
          <div
            className={`${css.carouselSlideWrapper} ${direction === 'right' ? css.slideRight : css.slideLeft}`}
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {imageUrls.map((url, index) => (
              <Image
                key={index}
                src={url}
                alt={alt}
                placeholder="blur"
                blurDataURL={placeholder}
                className={`${css.carouselImage} ${isCompactMode ? css.compactImage : ''} ${(imageUrls.length > 0 && !isFallbackImage && isImageHovered) ? css.hovered : ''}`}
                width={460}
                height={isCompactMode ? 118 : 260}
              />
            ))}
          </div>

          <div 
            className={`${enableHover ? css.carouselWrapper : ''}`} 
            onMouseEnter={enableHover ? handleMouseEnter : undefined}
            onMouseLeave={enableHover ? handleMouseLeave : undefined}
          >
            {imageUrls.length > 1 && currentIndex !== 0 && (
              <div className={css.leftArrowWrapper}>
                <button className={css.carouselArrow} onClick={goPrev}>
                  <img src={LeftNav} alt="Previous" />
                </button>
              </div>
            )}
            {imageUrls.length > 1 && currentIndex !== imageUrls.length - 1 && (
              <div className={css.rightArrowWrapper}>
                <button className={css.carouselArrow} onClick={goNext}>
                  <img src={RightNav} alt="Next" />
                </button>
              </div>
            )}
          </div>


          {imageUrls.length > 1 && (
            <div className={css.carouselDots}>
              {(() => {
                const dotsToRender = [];
                let start = 0;
                let end = Math.min(8, imageUrls.length);
                let showLeftSmallDot = false;
                let showRightSmallDot = false;

                if (imageUrls.length > 8) {
                  if (currentIndex <= 6) {
                    start = 0;
                    end = 7;
                    showRightSmallDot = true;
                  } else {
                    start = currentIndex - 6;
                    end = currentIndex + 1;
                    showLeftSmallDot = true;
                    if (end < imageUrls.length) showRightSmallDot = true;
                  }
                }

                if (showLeftSmallDot) {
                  dotsToRender.push(<span key="left-small" className={`${css.dot} ${css.smallDot}`} />);
                }

                for (let i = start; i < end; i++) {
                  const key = showLeftSmallDot
                    ? `${i}-${currentIndex}`
                    : i;
                  dotsToRender.push(
                    <span
                      key={i}
                      className={` ${css.dot} ${i === currentIndex ? css.active : ''}`}
                      onClick={() => selectIndex(i)}
                    />
                  );
                }

                if (showRightSmallDot) {
                  dotsToRender.push(<span key="right-small" className={`${css.dot} ${css.smallDot}`} />);
                }

                return dotsToRender;
              })()}
            </div>
          )}
        </div>
      </div>
    </div >
  );
};

export default connect()(Carousel);